// Form1.js - Defines the form "state" enumerations and functions.

// Third party modules;
import React from 'react';

// HelpBot modules;
import app from './app';
import Enum from './Enum';

export const FORM = Enum(
   {
      BEGIN : 'BEGIN', // Begin to fetch API data to build the form;
      BUILD : 'BUILD', // Build the form;
      CHECK : 'CHECK', // Check user input;
      DELAY : 'DELAY', // Delay after fail;
      ENACT : 'ENACT', // Enact form objective;
      FINAL : 'FINAL', // Final message or close form;
   }
); // FORM;

export const Form = ({ begin, build, check, class_string, enact, final, title, ...props }) => {

   const [body, set_body] = React.useState();
   const [data, set_data] = React.useState();
   const [foot, set_foot] = React.useState();
   const [form, set_form] = React.useState(FORM.BEGIN);
   const [pass, set_pass] = React.useState(1);
   const [warn, set_warn] = React.useState();

   const args   = {
      body: body, set_body: set_body,
      data: data, set_data: set_data,
      foot: foot, set_foot: set_foot,
      form: form, set_form: set_form,
      pass: pass, set_pass: set_pass,
      warn: warn, set_warn: set_warn
   }

   const submit = (event) => {
      event.preventDefault();
      set_form(FORM.CHECK);
   } // submit();

   React.useEffect(
      () => {

         // console.log('Form:useEffect():form=' + form);

         switch (form) {

         case FORM.BEGIN: default:
            if (begin) {
               begin(args);
            } else {
               set_form(FORM.BUILD);
            }
            break;

         case FORM.BUILD: 
            if (build) {
               args.warn = form_warn_format(warn);
               build(args); 
            }
            break;

         case FORM.DELAY: 
            if (build) {
               args.warn = form_warn_format('delay');
               build(args); 
            }
            setTimeout(
               () => { 
                  set_form(FORM.CHECK);
                  set_warn(null);
               }, 
               1000
            );
            break;

         case FORM.CHECK:
            if (check) {
               if (warn) {
                  set_form(FORM.DELAY);
               } else {
                  check(args);
               }
            } else {
               set_form(FORM.ENACT);// Send any requests to the API;
            }
            break;

         case FORM.ENACT:
            if (enact) enact(args);
            break;

         case FORM.FINAL:
            set_warn(null); 
            if (final) final(args);
            break;

         }

      },
      [data, form, pass]
   );

   return (
      <div className="ask-henry-form-hide">
        <div className={'ask-henry-form-wrap' + (class_string ? ' ' + class_string : '')}>
          <div className="ask-henry-form-head">{title}</div>
          <form className="ask-henry-form-body" onSubmit={submit}>
            {body}
            {foot}
          </form>
        </div>
      </div>
   );

} // <Form />

export const form_close = () => {
   app.set_state('mode', null);
} // form_close();

export const form_warn_format = (warn) => {
   if (!warn) return null;
   if ('delay' === warn) return <p className="ask-henry-body-margin-bottom-x">Processing. . .</p>;
   return <p className="ask-henry-form-warn ask-henry-body-margin-bottom-x">{warn}</p>;
} // form_warn_format();
